<template>
  <div class="header">
    <div @click="onBack" class="back">
      <img width="15px" src="../../image/imgs/fanhui.png" />
    </div>
    <div class="bar-wrapper" @click="handleFair">
      <div class="bar-img">
        <img
          round
          width="100%"
          height="100%"
          :src="robotInfo.header_img?robotInfo.header_img:''"
        />
      </div>
      <div class="bar-content">
        <div class="bar-title">Hi,我是{{robotInfo.robot_name ? robotInfo.robot_name : '客服助手'}}</div>
        <div
          class="bar-description"
        >{{robotInfo.robot_description?robotInfo.robot_description:'人工智能大模型AI+人工客服'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  components: {},
  props: {
    robotInfo: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {
    handleFair() {
      this.$router.push({
        path: "/fairInfo/" + this.robotInfo?.robot_code
      });
    },
    onBack() {
      this.$emit("onBack");
    }
  }
};
</script>

<style scoped lang="less">
.header {
  background: url("../../image/imgs/chat-bg.jpg") fixed top no-repeat;
  background-size: 100%;
  height: 80px;
  position: relative;
  .back {
    display: flex;
    align-items: center;
    position: absolute;
    top: 20px;
    left: 10px;
    font-weight: 600;
  }
  .bar-wrapper {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 0px;
    left: 20px;
    .bar-img {
      width: 20%;
      max-width: 45px;
      margin: 0 10px;
    }
    .bar-content {
      width: 80%;
    }
    .bar-title {
      font-weight: 550;
      font-size: 14px;
      margin: 5px 0;
    }
    .bar-description {
      color: rgb(131, 131, 131);
      font-size: 12px;
      margin: 5px 0;
      letter-spacing: 1px;
      line-height: 14px;
    }
  }
}
</style>
